import axios from "../../helpers/base";

export default () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/users")
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
